import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Landmark, ConciergeBell, Signpost, ArrowUpRight } from 'lucide-react';
import { useAuth } from '../AuthContext';
import { adminApi } from '../api';
import { SubscriptionBanner } from '../components/SubscriptionBanner';

const CARDS = [
  { key: 'events', label: 'Eventi', icon: Calendar, to: '/admin/section/events' },
  { key: 'places', label: 'Vicino a te', icon: MapPin, to: '/admin/section/places' },
  { key: 'museums', label: 'Arte & Musei', icon: Landmark, to: '/admin/section/museums' },
  { key: 'services', label: 'Servizi', icon: ConciergeBell, to: '/admin/section/services', feature: 'services' },
  { key: 'experiences', label: 'Esperienze', icon: Signpost, to: '/admin/section/experiences', feature: 'experiences' },
];

export function Dashboard() {
  const { user, isSuper, tenantId, hasFeature } = useAuth();
  const [counts, setCounts] = useState({});
  const cards = CARDS.filter((c) => !c.feature || hasFeature(c.feature));

  useEffect(() => {
    if (!tenantId && isSuper) return;
    (async () => {
      const out = {};
      for (const c of cards) {
        try { out[c.key] = (await adminApi.listEntities(c.key, isSuper ? tenantId : undefined)).length; }
        catch { out[c.key] = '-'; }
      }
      setCounts(out);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, isSuper]);

  return (
    <div>
      <h1 className="font-display text-3xl text-paelbi-ink">Benvenuto, {user?.name}</h1>
      <p className="mt-1 text-paelbi-ink/60">Gestisci i contenuti della piattaforma dal pannello.</p>

      <div className="mt-6"><SubscriptionBanner /></div>

      <div className="mt-2 grid grid-cols-2 gap-4 md:grid-cols-3">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} className="group rounded-2xl border border-paelbi-line bg-white p-5 shadow-card transition-all hover:-translate-y-1 hover:shadow-soft">
            <div className="flex items-center justify-between">
              <c.icon size={22} className="text-paelbi-brown" />
              <ArrowUpRight size={18} className="text-paelbi-ink/30 transition-colors group-hover:text-paelbi-brown" />
            </div>
            <p className="mt-4 font-display text-3xl text-paelbi-ink">{counts[c.key] ?? '…'}</p>
            <p className="text-sm text-paelbi-ink/60">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 rounded-2xl border border-paelbi-line bg-white p-6">
        <h2 className="font-display text-xl text-paelbi-ink">Suggerimenti</h2>
        <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-paelbi-ink/70">
          <li>Modifica testi in più lingue usando le schede IT/EN/DE/FR in ogni campo.</li>
          <li>Carica immagini dalla sezione Media o direttamente dai form (upload).</li>
          <li>Le convenzioni generano automaticamente un QR code univoco.</li>
          {isSuper && <li>Come super admin puoi cambiare la struttura attiva dal menu a sinistra.</li>}
        </ul>
      </div>
    </div>
  );
}

export default Dashboard;
